<template>
    <v-card class="background-create_cs_to_po-card" v-resize="onResize" v-if="isReady">
        <v-card-title v-if="windowSize.x > 1000" class="font-theme d-flex justify-space-between pa-0">
            <span
                style="font-weight: 400; font-size: calc(100% + 1.4vw); margin: 1.2% 0% 1.2% 2.8%; line-height: 45px; font-family: 'Sarabun', 'sans-serif';"
                class="text-center">
                CS to PO
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="ma-2" text x-large rounded outlined style="border-color:#424747" @click="goToDownloadReport()">
                            <!-- <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M17 17H17.01M17.4 14H18C18.9319 14 19.3978 14 19.7654 14.1522C20.2554 14.3552 20.6448 14.7446 20.8478 15.2346C21 15.6022 21 16.0681 21 17C21 17.9319 21 18.3978 20.8478 18.7654C20.6448 19.2554 20.2554 19.6448 19.7654 19.8478C19.3978 20 18.9319 20 18 20H6C5.06812 20 4.60218 20 4.23463 19.8478C3.74458 19.6448 3.35523 19.2554 3.15224 18.7654C3 18.3978 3 17.9319 3 17C3 16.0681 3 15.6022 3.15224 15.2346C3.35523 14.7446 3.74458 14.3552 4.23463 14.1522C4.60218 14 5.06812 14 6 14H6.6M12 15V4M12 15L9 12M12 15L15 12" stroke="#0b8e78" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg> -->
                            <svg width="35" fill="#72a4b0" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" stroke="#367591" stroke-width="0.00512"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"></path></g></svg> 
                        </v-btn>
                    </template>
                    <span class="font-theme">Download Report</span>
                </v-tooltip>
            </span>
            <span style="margin: 3.2% 3.2% 3.2% 0%;">
                <v-btn rounded class="menu_btn_create_cs_to_po" style="height:40px; width:120px" elevation="1" outlined
                    @click="confirmCreateCStoPO('WaitQT')">
                    <v-icon color="#139ad4" style="margin-right:3px;">
                        mdi-information-outline
                    </v-icon> Wait QT
                </v-btn>
                <v-btn rounded class="menu_btn_create_cs_to_po" elevation="1" outlined
                    style="margin-left: 10px; height:40px; width:120px" @click="confirmCreateCStoPO('SaveCsToPo')">
                    <v-icon color="#139ad4" style="margin-right:3px;">
                        mdi-information-outline
                    </v-icon>
                    บันทึก
                </v-btn>
                <v-btn rounded color="#0B68D6" class="white--text menu_btn_create_cs_to_po" elevation="1" 
                    style="margin-left: 10px; height:40px; width:120px" @click="confirmCreateCStoPO('RunPo')">
                    <v-icon color="#ffffff" style="margin-right:3px;">
                        mdi-export
                    </v-icon>
                    RUN PO
                </v-btn>
            </span>
        </v-card-title>
        <v-card-title v-else class="font-theme d-flex pa-0" style="border-bottom: 1px solid #BCB9B9;">
            <v-row no-gutters class="font-theme standard-row d-flex justify-space-between"
                style="padding: 3.8% 3.2% 3.8% 3.2%; line-height: 47px;">
                <v-col cols="11" sm="">
                    <span style="font-weight: 200; font-family: 'Sarabun'; font-size: calc(100% + 1.5vw);">CS to PO</span>
                </v-col>
                <v-col cols="1" sm="auto">
                    <v-menu offset-y transition="scroll-y-transition">
                        <template v-slot:activator="{ on }">
                            <v-btn icon v-on="on" color="#414040">
                                <v-icon size="30">mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>
                        <v-list style="background-color: #414040;">
                            <v-list-item dense @click="goToDownloadReport()">
                                <v-list-item-content>
                                    <v-list-item-title class="font-theme white--text"
                                        style="font-size: 13px; line-height: 25px;">
                                        Download Report
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item dense @click="confirmCreateCStoPO('WaitQT')">
                                <v-list-item-content>
                                    <v-list-item-title class="font-theme white--text"
                                        style="font-size: 13px; line-height: 25px;">
                                        Wait QT
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item dense @click="confirmCreateCStoPO('SaveCsToPo')">
                                <v-list-item-content>
                                    <v-list-item-title class="font-theme white--text"
                                        style="font-size: 13px; line-height: 25px;">
                                        บันทึก
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item dense @click="confirmCreateCStoPO('RunPo')">
                                <v-list-item-content>
                                    <v-list-item-title class="font-theme white--text"
                                        style="font-size: 13px; line-height: 25px;">
                                        RUN PO
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>

                        </v-list>
                    </v-menu>
                </v-col>
            </v-row>
        </v-card-title>
        <v-row no-gutters class="standard-row font-theme" style="padding: 0% 1.2% 1.8% 1.2%;">
            <v-data-table 
                fixed-header 
                dense 
                disable-sort 
                :headers="tableHeaders" 
                :items="groupedData"
                :group-by="groupField" 
                item-key="_id" 
                class="elevation-0 data-item-create_cs_to_po-table"
                style="width: 100%;" 
                v-model="selectedItems" 
                :server-items-length="countTransaction"
                :options.sync="optionsTransaction"
                :footer-props="{ 'items-per-page-options': [20, 30, 40, 50], 'items-per-page-text': 'จำนวนแถวต่อหน้า' }">
                <template v-if="CsTransaction.length < 20" v-slot:[`body.append`]="{ isMobile }">
                    <tr v-for="(_, index_tr) in (20 - CsTransaction.length)" :key="`tr__${index_tr}`" v-show="!isMobile">
                        <td v-for="(_, index_td) in 12" :key="`td__${index_td}`"></td>
                    </tr>
                </template>
                <template v-slot:[`footer.page-text`]="items">
                    {{ items.pageStart }} - {{ items.pageStop }} จาก {{ items.itemsLength }} แถว
                </template>
                <template v-slot:[`group.header`]="{ group, isOpen, toggle }">
                    <th style="width: 16px;">{{ group }}</th>
                    <th style="text-align: left;">
                        <v-icon @click="toggle">{{ isOpen ? 'mdi-menu-up' : 'mdi-menu-down' }}
                        </v-icon>
                    </th>
                    <th colspan="6"></th>
                    <th>
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" align=center>
                                    <svg xmlns="http://www.w3.org/2000/svg" style="color:#7f7d7d;" width="22" height="22"
                                        fill="currentColor" class="bi bi-file-earmark-fill" viewBox="0 0 16 16">
                                        <path
                                            d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3z" />
                                    </svg>
                                </v-btn>
                            </template>
                            <span class="font-theme">ดูเอกสาร</span>
                        </v-tooltip>
                    </th>
                    <th colspan="2"></th>
                    <th>
                        <v-checkbox v-model="selectedGroups[group]" @change="groupCheckboxChanged(group)" color="#00AA1B"
                            on-icon="mdi-radiobox-marked" off-icon="mdi-radiobox-blank"></v-checkbox>
                    </th>
                </template>
                <template v-slot:[`item.so_number`]="{ item }">
                    {{ item.so_number || '–' }}
                </template>
                <template v-slot:[`item.document_id`]="{ item }">
                    {{ item.document_id || '–' }}
                </template>
                <template v-slot:[`item.job_status`]="{ item }">
                    {{ item.job_status || '–' }}
                </template>
                <template v-slot:[`item.group_service`]="{ item }">
                    {{ item.group_service || '–' }}
                </template>
                <template v-slot:[`item.service_name`]="{ item }">
                    {{ item.service_name || '–' }}
                </template>
                <template v-slot:[`item.unit`]="{ item }">
                    {{ item.unitFormatted || '–' }}
                </template>
                <template v-slot:[`item.unit_type`]="{ item }">
                    {{ item.unit_typeFormatted || '–' }}
                </template>
                <template v-slot:[`item.actual`]="{ item }">
                    {{ item.actualFormatted || '–' }}
                </template>
                <template v-slot:[`item.file`]="{ item }">
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-btn icon v-on="on" align=center>
                                <svg xmlns="http://www.w3.org/2000/svg" style="color:#7f7d7d;" width="22" height="22"
                                    fill="currentColor" class="bi bi-file-earmark-fill" viewBox="0 0 16 16">
                                     <path d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3z" />
                                </svg>
                            </v-btn>
                            </template>
                            <span class="font-theme">ดูเอกสาร</span>
                    </v-tooltip>
                </template>
                <template v-slot:[`item.qt_value`]="{ item }">
                    <v-text-field align="center" v-model="item.qt_value" @input="subGroupCheckboxChanged(item)" outlined dense hide-details :rules=[rules.number]></v-text-field>
                </template><template v-slot:[`item.qt_vendor`]="{ item }">
                    <v-text-field align="center" v-model="item.qt_vendor" @input="subGroupCheckboxChanged(item)" outlined dense hide-details></v-text-field>
                </template><template v-slot:[`item.action`]="{ item }">
                    <v-checkbox v-model="selectedItem[item._id]" @change="subGroupCheckboxChanged(item)" color="#00AA1B"
                        on-icon="mdi-radiobox-marked" off-icon="mdi-radiobox-blank">
                    </v-checkbox>
                </template>
            </v-data-table>
        </v-row>
        <div>
            <ConfirmCreateCStoPO ref="confirmDialog" />
            <DownloadReportModal />
        </div>
    </v-card>
</template>

<script>
import { EventBus } from '../EventBus'
import { MainFunction } from '@/functions/mainFunction.js'
import ConfirmCreateCStoPO from '../components/ConfirmCreateCStoPO.vue';
import DownloadReportModal from '../components/DownloadReportModal.vue'
export default {
    components: {
        ConfirmCreateCStoPO,
        DownloadReportModal
    },
    data: () => ({
        headers: [
            { text: "Sale Document", align: "center", sortable: false, width: '10%', value: "sale_document" },
            { text: "Document_id", align: "center", sortable: false, width: '10%', value: "document_id" },
            { text: "Job_Status", align: "center", sortable: false, value: "job_status" },
            { text: "Group_Service", align: "center", sortable: false, value: "group_service" },
            { text: "Service_Name", align: "center", sortable: false, value: "service_name" },
            { text: "Unit", align: "center", sortable: false, value: "unit" },
            { text: "Unit_Type", align: "center", sortable: false, value: "unit_type" },
            { text: "Actual", align: "center", sortable: false, value: "actual" },
            { text: "File", value: "File", align: "center", sortable: false },
            { text: "QT Vendor", align: "center", sortable: false, value: "QT_Vendor" },
            { text: "QT Value", align: "center", sortable: false, value: "QT_Value" },
            { text: "", align: "center", sortable: false, value: "action" },
        ],
        tableHeaders: [
            { text: "Sale Document", align: "center", value: "sale_document", width: "8%" },
            { text: 'Document ID', align: "center", value: 'document_id' },
            { text: 'Job Status', align: "center", value: 'job_status' },
            { text: 'Group Service', align: "center", value: 'group_service' },
            { text: 'Service Name', align: "center", value: 'service_name' },
            { text: 'Unit', align: "center", value: 'unit' },
            { text: 'Unit Type', align: "center", value: 'unit_type' },
            { text: 'Actual', align: "center", value: 'actual' },
            { text: 'File', align: "center", value: 'file' },
            { text: 'QT Vendor', align: "center", value: 'qt_vendor' },
            { text: 'QT Value', align: "center", value: 'qt_value' },
            { text: "", align: "center", value: "action" },
        ],
        isOpenMap: {},
        selectedItems: [],
        expanded: [],
        isReady: true,
        windowSize: { x: 0, y: 0 },
        memoTransaction: [],
        selectedItem: {},
        selectedHeader: [],
        optionsTransaction: {
            "page": 1,
            "itemsPerPage": 20
        },
        callApiPending: 0,
        countTransaction: 0,
        CsTransaction: [],
        groupField: 'so_number',
        selectedGroups: {},
        selectedItemsConfirm: [],
        rules: {
            required: value => !!value || 'Required.',
            number: value => {
                const pattern = /^\d+(\.\d+)*$/
                return pattern.test(value) || 'Invalid value.'
            },
        },
    }),
    mounted() {
        this.onResize()
        // this.processCsTransaction()
        this.getTransaction()
    },
    computed: {
        groupedData() {
            // Flatten the nested data structure
            const flatData = this.CsTransaction.reduce((acc, curr) => {
                return [...acc, ...curr.cs_list.map(item => ({
                    ...item, so_number: curr.so_number,
                    actualFormatted: MainFunction.addComma(parseFloat(item.actual.replace(/,/g, '').trim()) || 0),
                    unitFormatted: MainFunction.addComma(parseFloat(item.unit.replace(/,/g, '').trim()) || 0),
                    unit_TypeFormatted: MainFunction.addComma(parseFloat(item.unit_type.replace(/,/g, '').trim()) || 0),
                }))];
            }, []);
            return flatData;
        }
    },
    watch: {
        "optionsTransaction.page"(newValue) {
            if (newValue != 1 || !this.isChangeTab) {
                this.getTransaction()
                this.trigRowPerPage = true
            }
        },
        "optionsTransaction.itemsPerPage"() {
            if (!this.trigRowPerPage) {
                this.optionsTransaction.page = 1
                this.getTransaction()
            }
        },
        "permissionTabs"() {
            this.checkPageForGetTransaction()
        },
        "documentDwfStatus"() {
            this.optionsTransaction.page = 1
            this.getTransaction()
            this.isChangeTab = true
        },
        "callApiPending"(val) {
            if (val > 0) {
                EventBus.$emit('loadingState', true)
            } else {
                EventBus.$emit('loadingState', false)
            }
        }
    },
    methods: {
        onResize() {
            this.windowSize = { x: window.innerWidth };
        },
        processCsTransaction() {
            this.CsTransaction.forEach((el) => {
                el.so_number = el.SaleDocument
            });
        },
        toggleGroup(Sale_Document) {
            this.$set(this.isOpenMap, Sale_Document, !this.isOpenMap[Sale_Document]);
            console.log(this.isOpenMap);
        },

        toggleSubGroupCheckbox(value) {
            this.selectedItem[value] = true
            console.log(value);
        },
        groupCheckboxChanged(group) {
            this.selectedItemsConfirm = []
            // Handle changes in group checkboxes
            const groupItems = this.groupedData.filter(item => item.so_number === group);
            if (this.selectedGroups[group]) {
                groupItems.forEach(item => {
                    this.$set(this.selectedItem, item._id, {
                        ...item,
                        checkbox: true
                    });
                });
            } else {
                groupItems.forEach(item => {
                    this.$delete(this.selectedItem, item._id);
                });
            }
            for (const [key, value] of Object.entries(this.selectedItem)) {
                this.selectedItemsConfirm.push(value)
            }
        },
        subGroupCheckboxChanged(subgroup) {
            this.selectedItemsConfirm = []
            const subgroupItems = this.groupedData.filter(item => item._id == subgroup._id)
            if (this.selectedItem[subgroup._id]) {
                subgroupItems.forEach(item => {
                    this.$set(this.selectedItem, item._id, {
                        ...item,
                        checkbox: true,
                        qt_vendor: item.qt_vendor || "",
                        qt_value: item.qt_value || ""
                    });
                })
            } else {
                this.selectedGroups[subgroup.sale_document] = false
                subgroupItems.forEach(item => {
                    this.$delete(this.selectedItem, item._id);
                })
            }
            for (const [key, value] of Object.entries(this.selectedItem)) {
                this.selectedItemsConfirm.push(value)
            }
        },
        alert(title = '', text = 'Fail', icon = 'info') {
            this.$swal({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                icon: icon,
                title: `<b class="alert-success-title">${title}</b>`,
                text: text,
                showClass: {
                    popup: 'animate-show-card'
                },
                customClass: {
                    container: 'alert-card-block',
                    popup: 'alert-card-success',
                    title: 'alert-title-block',
                    htmlContainer: 'alert-text-box',
                    icon: 'alert-icon'
                }
            });
        },
        async getTransaction() {
            // if (!this.myPermission.length) {
            //     return this.alert('ไม่พบสิทธิ์การเข้าถึง', 'Warning', 'info')
            // }
            try {
                this.callApiPending++
                const countTransactions = {
                    baseURL: this.$api_url,
                    url: `/cs_to_po/api/v1/count_cs_to_po`,
                    method: 'GET'
                }
                const searchTransactions = {
                    baseURL: this.$api_url,
                    url: `/cs_to_po/api/v1/get_cs_to_po?limit=${this.optionsTransaction.itemsPerPage || 20}&page=${this.optionsTransaction.page  || 1}`,
                    method: 'GET'
                }
                const data = await Promise.all([this.axios(countTransactions), this.axios(searchTransactions)])
                this.countTransaction = data[0].data.data
                this.CsTransaction = data[1].data.data
            } catch (error) {
                this.alert('กรุณาลองใหม่อีกครั้ง', 'Fail', 'error')
                console.log(error)
            } finally {
                this.callApiPending--
                this.isChangeTab = false
                this.trigRowPerPage = false
                if (!this.callApiPending) {
                    this.isReady = true
                }
            }
        },
        // confirmCreateCStoPO() {
        //     this.$refs.confirmDialog.open(this.selectedItemsConfirm );
        // },
        goToDownloadReport(){
            const aboutReport = {
                url        : '/report/api/v1/export_report_cs_to_po',
                // permission : this.permissionTabs.inbox,
                from       : 'create_cs_po'
            }
            EventBus.$emit('openDownloadReportModal', aboutReport)
        },
        confirmCreateCStoPO(action) {
            this.action = action;
            if (!this.selectedItemsConfirm || this.selectedItemsConfirm.length === 0) {
                this.alert('กรุณาเลือกรายการก่อนยืนยัน', 'Warning', 'info');
                return;
            }
            if((action == 'SaveCsToPo' || action == 'RunPo') && !this.allAreEqual(this.selectedItemsConfirm)){
                this.alert('กรุณาเลือกรายการที่มีข้อมูลวันที่เริ่มต้น - วันที่สิ้นสุดและ QT vendor ตรงกัน', 'Warning', 'info');
                return
            }
            this.$refs.confirmDialog.open(this.selectedItemsConfirm, action);
        },
        allAreEqual(array) {
            const result = array.every(element => {
                if (element.p_so_04 === array[0].p_so_04 && element.p_so_05 === array[0].p_so_05 && element.qt_vendor === array[0].qt_vendor) {
                    return true;
                }
            });
            return result;
        }
    }
}
</script>

<style>
.background-create_cs_to_po-card {
    box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.25) !important;
    margin: 60px 4.51% 56px 4.51% !important;
    border-radius: 23px !important;
}

.data-item-create_cs_to_po-table thead th {
    height: 39px !important;
    background-color: #333333 !important;
    color: #FFFFFF !important;
    font-size: 12px;
}

.data-item-create_cs_to_po-table thead th:first-child {
    border-radius: 10px 0 0 0;
}

.data-item-create_cs_to_po-table thead th:last-child {
    border-radius: 0 10px 0 0;
}

.data-item-create_cs_to_po-table thead th {
    font-size: 12px !important;
    font-weight: 400;
}

.data-item-create_cs_to_po-table.v-data-table--fixed-header>.v-data-table__wrapper>table>thead>tr>th {
    position: sticky;
    top: 0;
    z-index: 2;
}

.data-item-create_cs_to_po-table .v-data-table__wrapper table tbody tr td {
    padding-top: 0px;
    height: 49px !important;
    font-size: 10px;
}

.data-item-create_cs_to_po-table tbody tr td {
    border-left: 0px solid #D8D5D5 !important;
    border-right: 0px solid #D8D5D5 !important;
    border-bottom: 0px !important;

}

.data-item-create_cs_to_po-table tbody tr td:first-child {
    border-left: 0px !important;
    border-right: 0px solid #D8D5D5 !important;
    border-bottom: 0px !important;
}

.data-item-create_cs_to_po-table tbody tr td:last-child {
    border-left: 1px solid #D8D5D5 !important;
    border-right: 0px !important;
    border-bottom: 0px !important;
}

.data-item-create_cs_to_po-table tbody tr:nth-of-type(even) {
    background: #F8F5F5;
}

.data-item-create_cs_to_po-table .v-data-table__wrapper table tbody tr td {
    border-left: none !important;
}

.data-item-create_cs_to_po-table.v-data-table>.v-data-table__wrapper {
    height: calc(100vh - 174px);
    overflow: auto;
    scroll-behavior: smooth;
}

.data-item-create_cs_to_po-table.v-data-table>.v-data-table__wrapper::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: transparent !important;
}

.data-item-create_cs_to_po-table.v-data-table>.v-data-table__wrapper::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: transparent !important;
}

.data-item-create_cs_to_po-table.v-data-table>.v-data-table__wrapper::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #F8F5F5;
}

.v-data-table>.v-data-table__wrapper>table>tbody>tr>td,
.v-data-table>.v-data-table__wrapper>table>tbody>tr>th,
.v-data-table>.v-data-table__wrapper>table>thead>tr>td,
.v-data-table>.v-data-table__wrapper>table>thead>tr>th,
.v-data-table>.v-data-table__wrapper>table>tfoot>tr>td,
.v-data-table>.v-data-table__wrapper>table>tfoot>tr>th {
    padding: 0 10px;
    transition: height 0.2s cubic-bezier(0.4, 0, 0.6, 1);
}

.menu_btn_create_cs_to_po {
    font-weight: 500;
    font-size: 12px;
    border: 1px solid #424747 !important;
    border-radius: 20px;
}

@media only screen and (max-width: 849px) {
    .data-item-create_cs_to_po-table .v-data-table__wrapper table tbody .v-data-table__empty-wrapper td {
        width: 100vw;
        border-right: none !important;
        border-bottom: none !important;
    }
}</style>
